<div class="card card-body">
  <div class="d-flex flex-row justify-space-between align-items-center">
    <div class="d-flex flex-grow-1">
      {{ 'general.pick_language_l' | translate }}
    </div>
    <app-lang-picker
      [availableLanguages]="availableLanguages"
      [defaultLanguageCode]="defaultLanguageCode"
      [ngModel]="currentLanguageCode"
      (ngModelChange)="onLanguageChange($event)"
    >
    </app-lang-picker>
  </div>
  <hr />
  <div class="mb20">
    <img [src]="logo" alt="customer-logo" />
  </div>

  <h1 class="title-m mb20">
    {{ 'self_registration.intro_header_l' | translate }}
  </h1>

  <p class="mb20">{{ 'self_registration.intro_explanation_l' | translate }}</p>
  <p class="mb20">
    {{ 'contact.selfRegistration_data_security_l' | translate }}
  </p>

  @if (hasUrl) {
    <div class="d-flex mb20">
      <span class="me-1 link blue" (click)="openLink()">{{
        'contact.selfRegistration_data_security_link_l' | translate
      }}</span>
      <span
        >{{ 'contact.selfRegistration_data_security_link_text_l' | translate }}
      </span>
    </div>
  }

  <div class="d-flex justify-content-center">
    <app-button [type]="'primary'" (clickEvent)="goToWizard()">
      {{ 'self_registration.intro_redirect_to_wizard_a' | translate }}
    </app-button>
  </div>
</div>
